import { render, staticRenderFns } from "./allreceipts.vue?vue&type=template&id=be7572de"
import script from "./allreceipts.vue?vue&type=script&lang=js"
export * from "./allreceipts.vue?vue&type=script&lang=js"
import style0 from "./allreceipts.vue?vue&type=style&index=0&id=be7572de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports